import { defineComponent, onBeforeMount, provide } from 'vue'
import { getLandingContentCall } from '@/api/landing'
import TheFooter from '@/components/landing/layout/TheFooter.vue'
import TheHeader from '@/components/landing/layout/TheHeader.vue'
import { useApiCall } from '@/composables/useApiCall'

export default defineComponent({
  name: 'LandingLayout',
  components: {
    TheHeader,
    TheFooter,
  },
  setup() {
    const { isLoading, executeApiCall: getContent, data: contentData } = useApiCall(getLandingContentCall, true)
    provide('contentData', contentData)

    onBeforeMount(async () => getContent())

    return { isLoading }
  },
})
